// CROWN & CO. — ported from getcrownandco.com inline <script>
(function () {
  const init = () => {
    // nav background on scroll
    const navWrap = document.getElementById('navWrap');
    if (navWrap) {
      const onScroll = () => {
        navWrap.classList.toggle('scrolled', window.scrollY > 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // mobile menu
    const toggle = document.querySelector('.menu-toggle');
    const mobileMenu = document.getElementById('mobileMenu');
    if (toggle && mobileMenu) {
      toggle.addEventListener('click', () => {
        const open = mobileMenu.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
      mobileMenu.querySelectorAll('a').forEach((a) =>
        a.addEventListener('click', () => {
          mobileMenu.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        })
      );
    }

    // reveal on scroll
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const e of entries) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              io.unobserve(e.target);
            }
          }
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );
      document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
    } else {
      document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
    }

    window.addEventListener('load', () => {
      document.querySelectorAll('.hero .reveal').forEach((el) => el.classList.add('is-in'));
    });

    // benefit tabs (RYZE-style segmented switcher) — scoped per .benefits section
    document.querySelectorAll('.benefits').forEach((root) => {
      const tabs = root.querySelectorAll('.benefit-tab');
      const panels = root.querySelectorAll('.benefit-panel');
      if (!tabs.length) return;
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const i = tab.getAttribute('data-tab');
          tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          panels.forEach((p) =>
            p.classList.toggle('is-active', p.getAttribute('data-panel') === i)
          );
        });
      });
    });

    // Newsletter success is handled natively by Shopify's {% form 'customer' %}.
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
